import { UpdateFirmMemberInput } from '../../../../generated/graphql';
import { FirmMemberFormValues } from '..';

interface GetUpdateFirmMemberInputFromFormValuesArgs {
  formValues: FirmMemberFormValues;
  metaData: {
    firmMemberID: string;
    changeToken: string;
  };
}

export function getUpdateFirmMemberInputFromFormValues({
  metaData,
  formValues,
}: GetUpdateFirmMemberInputFromFormValuesArgs): UpdateFirmMemberInput {
  return {
    id: metaData.firmMemberID,
    changeToken: metaData.changeToken,
    changes: {
      calendarSchedulingLink: formValues.calendarSchedulingLink,
    },
  };
}
